// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","9066":"dc112a36"}[chunkId] || chunkId) + "." + {"501":"06dd6805e77e797b","822":"f811e1e3dc83ede8","2121":"1610fb7c0e21a19a","3770":"4b18ef0a5727b2fe","9066":"95e92d0c78033731"}[chunkId] + ".js";
};